<style lang="less" scoped>
.table-pagination-container{
    margin-top: 16px;
}
</style>

<template>
    <div class="table-pagination-container flex-center">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.current" :page-sizes="pagination.pageSizes" :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
            </el-pagination>
    </div>
</template>

<script>
    export default {
        name:'ZDPagination',
        props: {
            pagination:{
                type:Object,
                default:{},
            },
        },
        data() {
            return {
            }
        },
        methods: {
            handleSizeChange(e){
                this.pagination.pageSize = e;
                this.pagination.current = 1;
                this.$emit('pageUpdate',this.pagination);
            },
            handleCurrentChange(e){
                this.pagination.current = e;
                this.$emit('pageUpdate',this.pagination);
            },
        },
        mounted() {
        },
    }
</script>